import TopCategoryWithSubcategoriesCollapse from './TopCategoryWithSubcategoriesCollapse'

export default TopCategoryWithSubcategoriesCollapse
